import { render, staticRenderFns } from "./ProductDiscountCustomersPrintReport.vue?vue&type=template&id=b10f677c&scoped=true&"
import script from "./ProductDiscountCustomersPrintReport.vue?vue&type=script&lang=js&"
export * from "./ProductDiscountCustomersPrintReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscountCustomersPrintReport.vue?vue&type=style&index=0&id=b10f677c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10f677c",
  null
  
)

export default component.exports